import {ScreenOrientation} from '@gongxigames/framework/core';
import {IScrollToFullscreen} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/IScrollToFullscreen';
import {createScrollContainer, SHOWN_SCROLL_CONTAINER_STYLE_CLASS} from '@gongxigames/framework/slot/modules/iOSFullscreen/scrollToFullscreen/createScrollContainer';

type BarHeight = {
    PORTRAIT: number;
    LANDSCAPE: number;
};

export class ScrollForOldVersionIOS implements IScrollToFullscreen {

    static CHROME_BAR_HEIGHT: BarHeight = {
        PORTRAIT: 70,
        LANDSCAPE: 26
    };

    static SAFARI_BAR_HEIGHT: BarHeight = {
        PORTRAIT: 64,
        LANDSCAPE: 44
    };

    private readonly _scrollContainer: HTMLElement;
    private readonly _bodyClassList: DOMTokenList;
    private readonly _barHeight: BarHeight;

    constructor(isSafari: boolean) {
        this._barHeight = isSafari ? ScrollForOldVersionIOS.SAFARI_BAR_HEIGHT : ScrollForOldVersionIOS.CHROME_BAR_HEIGHT;
        this._bodyClassList = document.body.classList;
        this._scrollContainer = createScrollContainer();

        document.body.appendChild(this._scrollContainer);

        this.hide();
    }

    public destroy(): void {
        if (this._scrollContainer.parentNode) {
            document.body.appendChild(this._scrollContainer);
        }

        this._bodyClassList.remove(SHOWN_SCROLL_CONTAINER_STYLE_CLASS);
    }

    public show(): void {
        this._scrollContainer.style.visibility = 'visible';

        this._bodyClassList.add(SHOWN_SCROLL_CONTAINER_STYLE_CLASS);
    }

    public hide(): void {
        this._scrollContainer.style.visibility = 'hidden';

        this._bodyClassList.remove(SHOWN_SCROLL_CONTAINER_STYLE_CLASS);

        window.scrollBy(0, 0);
    }

    public isFullscreen(orientation: ScreenOrientation): boolean {
        if (orientation === ScreenOrientation.LANDSCAPE) {
            return window.innerHeight + this._barHeight.LANDSCAPE >= screen.width;
        } else {
            return true;
        }
    }

    private onGestureStart(e: Event): void {
        e.preventDefault();
    }
}
